import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IRIFormProps } from '../../../_core/form/form.types';
import { FormActionsRow } from '../../../_core/form/input/form-actions-row';
import { IGetUserInviteCodeProps, IRequestAccess } from '../user-invite-code.types';
import { isValidEmail } from '../../../../utils/validation.helpers';

export const FetchUserInviteCodeForm = ({
  code = '',
  onBack,
  onRequestAccess,
  onSubmit
}: IRIFormProps<IGetUserInviteCodeProps> & IRequestAccess & { code?: string }) => {
  const validateForm = (values: IGetUserInviteCodeProps) => {
    const errors: FormikErrors<IGetUserInviteCodeProps> = {};

    if (!values.code.trim()) errors.code = 'Required';

    const email = values.email.trim();
    if (!email || !isValidEmail(email)) errors.email = 'Must enter valid email';

    return errors;
  };

  const onSubmitForm = async (props: FormikProps<IGetUserInviteCodeProps>) => {
    props.setSubmitting(true);

    const errors = await validateForm(props.values);
    if (Object.keys(errors).length) {
      await Promise.all(
        Object.entries(errors).map(([field, error]) =>
          props.setFieldTouched(field, true).then(() => props.setFieldError(field, error))
        )
      );
    } else await props.submitForm();

    props.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{ code, email: '' }}
      onSubmit={({ code, email }) => onSubmit({ code: code.trim(), email: email.trim() })}
    >
      {(props: FormikProps<IGetUserInviteCodeProps>) => (
        <Form action="#" method="POST" className="sm:max-w-xl mx-auto space-y-4 mt-10">
          <FormInputWithLabel name="email" label="Email" placeholder="Enter email..." />
          <FormInputWithLabel name="code" label="Code" placeholder="Enter code..." disabled={!!code} />
          <div className="text-xs">
            If you do not have an invite code please{' '}
            <a className="inline-block cursor-pointer text-blue-600 hover:text-blue-500" onClick={onRequestAccess}>
              contact us
            </a>
          </div>
          <FormActionsRow>
            {!!onBack && <FormButton onPress={onBack} text="Cancel" type="button" variant="secondary" />}
            <FormButton loading={props.isSubmitting} text="Submit" type="button" onPress={() => onSubmitForm(props)} />
            {!!props.values.code && !!props.values.email && (
              <div style={{ display: 'none' }}>
                <FormButton text="Hidden Submit" />
              </div>
            )}
          </FormActionsRow>
        </Form>
      )}
    </Formik>
  );
};
